import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { MaterialModule } from 'src/app/material.module';
import { DashboardModule } from '../dashboard-documente/dashboard.module';
import { ActivityFiltersModule } from '../shared/activity-filters/activity-filters.module';
import { MatrixDrillDownTableComponent } from './components/matrix-drill-down-table/matrix-drill-down-table.component';
import { MatrixFromToTableComponent } from './components/matrix-from-to-table/matrix-from-to-table.component';
import { MatrixNedistribuiteComponent } from './components/matrix-nedistribuite/matrix-nedistribuite.component';
import { MatrixSummaryWidgetsComponent } from './components/matrix-summary-widgets/matrix-summary-widgets.component';
import { RaportActivitateDetaliatComponent } from './raport-activitate-detaliat.component';

@NgModule({
    declarations: [
        RaportActivitateDetaliatComponent,
        MatrixSummaryWidgetsComponent,
        MatrixFromToTableComponent,
        MatrixDrillDownTableComponent,
        MatrixNedistribuiteComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        DataTablesModule,
        ActivityFiltersModule,
        DashboardModule,
    ],
    exports: [RaportActivitateDetaliatComponent],
})
export class RaportActivitateDetaliatModule {}
